import React from 'react'
import PropTypes from 'prop-types'
import AppStore from '../../../stores/AppStore'

import styles from '../../../../css/scheduler.module.css'

export default function EventBlock (props) {
  const { handleUpdateEvent, event } = props
  const { level } = AppStore.getUser()?.permissions || { level: 0 }

  const classes = event.duration.cross ? [styles.multi_day_event] : []
  const className = classes.join(' ')

  const height = (() => {
    if (!event || !event.duration || !event.duration.size) {
      return {
        height: '40px',
      }
    }
    let blocks = 1
    if (event.duration.size > 0) {
      blocks = event.duration.size + 1
    }
    let height = blocks > 0 ? 40 * (blocks - 1) + 40 : 40
    if (event.duration.days > 0 && event.stop.day > event.start.day) {
      height += 50
      if (event.duration.days > 1) {
        height += 90 * (event.duration.days - 1)
      }
    }
    return {
      height: `${height}px`,
    }
  })()

  const text = `${event.start.human} - ${event.stop.human}`

  return (
    <div
      className={`${styles.event} ${className}`}
      style={height}
      onMouseDown={e => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation()
        if (level >= 10) handleUpdateEvent(event.key)
      }}
    >
      <span className={styles.event_times}>{text}</span>
    </div>
  )
}

EventBlock.propTypes = {
  event: PropTypes.object.isRequired,
  handleUpdateEvent: PropTypes.func.isRequired,
}
